import React, { useState } from "react";
import { Modal, Tab } from "semantic-ui-react";
import MeHealthCreditUsageTab from "./MeHealthCreditUsageTab";
import MeHealthPaymentHistoryTab from "./MeHealthPaymentHistoryTab";

const COLOR = {
  primary: "var(--primary-theme-color)",
  gray: "#a7a7a7",
};

const ICON = {
  IconDownload: "/static/images/icon_download.png",
};

type MeHealthHistoryModalProps = {
  open: boolean;
  onClose: () => void;
  BillingAndPackageSequence: any;
  runSequence: any;
  setProp: any;
  BillingCreditWallet: any;
}

const MeHealthHistoryModal = (props: MeHealthHistoryModalProps) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const panes = [
    {
      menuItem: "ประวัติการชำระ",
      render: () => (
        <Tab.Pane>
          <MeHealthPaymentHistoryTab
            setProp={props.setProp}
            BillingAndPackageSequence={props.BillingAndPackageSequence}
            runSequence={props.runSequence}
            primaryColor={COLOR.primary}
            borderColor={COLOR.gray}
            downloadIconSrc={ICON.IconDownload}
            onClose={props.onClose}
            closeButtonColor={COLOR.gray}
          />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "ประวัติการตัดใช้ Credit",
      render: () => (
        <Tab.Pane>
          <MeHealthCreditUsageTab 
            setProp={props.setProp}
            BillingAndPackageSequence={props.BillingAndPackageSequence} 
            BillingCreditWallet={props.BillingCreditWallet}
            runSequence={props.runSequence}
            primaryColor={COLOR.primary}
            borderColor={COLOR.gray}
            onClose={props.onClose}
            closeButtonColor={COLOR.gray}
          />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      size="large"
      style={{ minHeight: "550px", maxHeight: "550px" }}
      id="CardBuyBillingPackageModal"
    >
      <Modal.Content>
        <Tab
          panes={panes}
          activeIndex={activeTabIndex}
          onTabChange={(e, data) => setActiveTabIndex(Number(data.activeIndex))}
          menu={{ className: "custom-history-tab-menu" }}
        />
      </Modal.Content>
    </Modal>
  );
};

export default MeHealthHistoryModal;
